import React from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  withHandlers,
  withState,
  setDisplayName,
  lifecycle
} from 'recompose';
import MediaQuery from 'react-responsive';
import { Card } from '@scotia/canvas-react';
import {
  TableBody,
  TableHeader,
  TableRow,
  TableHeaderData,
  Table
} from '@scotia/canvas-react';
import { TableStoreRows } from './TableStoreRow';
import style from './TableStore.scss';
import { CardTitle } from '../Typography';

const enhance = compose(
  setDisplayName('TableStore'),
  withState('currentPage', 'setPage', 0),
  withState('total', 'setTotal'),
  withState('columns', 'setColumns', []),
  withState('disabled', 'setNextDisabled', false),
  withState('rows', 'setRows', []),
  lifecycle({
    componentDidMount() {
      const {
        rows,
        currentPage,
        setRows,
        setPage,
        setTotal,
        setColumns,
        setNextDisabled,
        store: { load }
      } = this.props;
      if (typeof load !== 'function') {
        console.error('Debe definirse la funcion load.');
      }
      const columns = React.Children.map(this.props.children, col => col.props);
      if (!Array.isArray(columns)) {
        console.error('Deben definirse las columnas');
      }
      setColumns(columns);
      typeof load === 'function' &&
        load({
          currentPage,
          rows,
          setRows,
          setPage,
          setTotal,
          setNextDisabled,
          setColumns
        });
    }
  }),
  withHandlers({
    next: ({
      rows,
      currentPage,
      setPage,
      setRows,
      setNextDisabled,
      store: { load }
    }) => () => {
      load({ currentPage, setPage, rows, setRows, setNextDisabled });
    }
  })
);
export const TableStoreColumn = () => <React.Fragment />;
export const TableStore = enhance(
  ({
    renderPaging,
    disabled,
    rows,
    store: { mapping },
    next,
    columns,
    maxDeviceWidth
  }) => (
    <React.Fragment>
      <MediaQuery
        minDeviceWidth={maxDeviceWidth}
        query={`(min-width: ${maxDeviceWidth}px)`}
      >
        <Table>
          <TableHeader>
            <TableRow>
              {columns.map(({ text, id }, i) => (
                <TableHeaderData key={id || i}>
                  <CardTitle className={style['text-store']}>
                    {typeof text === 'function' ? text() : text}
                  </CardTitle>
                </TableHeaderData>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>{TableStoreRows(columns, mapping, rows, false)}</TableBody>
        </Table>
      </MediaQuery>
      <MediaQuery
        maxDeviceWidth={maxDeviceWidth}
        query={`(max-width: ${maxDeviceWidth}px)`}
      >
        <Card style={{ padding: 0 }}>
          <Table>
            <TableBody>
              {TableStoreRows(columns, mapping, rows, true)}
            </TableBody>
          </Table>
        </Card>
      </MediaQuery>
      <div className={style['paging-store']}>
        {renderPaging({ next, disabled })}
      </div>
    </React.Fragment>
  )
);
TableStore.propTypes = {
  /** Number for max device width (default. 922) */
  maxDeviceWidth: PropTypes.number,
  /** Store for load data. Define 'load' and 'mapping' functions. */
  store: PropTypes.shape({
    load: PropTypes.func,
    mapping: PropTypes.func
  }).isRequired,
  /** Array of TableStoreColumn */
  children: PropTypes.array.isRequired,
  /** Paging render prop */
  renderPaging: PropTypes.func.isRequired
};

TableStoreColumn.propTypes = {
  /** Text table header */
  text: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
  /** Field of data store for column*/
  index: PropTypes.string.isRequired,
  /** Render function for data column */
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element,
    PropTypes.func
  ])
};

TableStore.defaultProps = {
  maxDeviceWidth: 922,
  pageSize: 10
};
